import ManageFirm from '@advisor/models/store/manageFirm/index';
// eslint-disable-next-line import/no-cycle
import ManageFirmService from '@advisor/services/ManageFirm';
import {returnNoneApi} from '@advisor/util/returnNoneApi';
import exceptionHandler from '@advisor/util/exceptionHandler';
import principalAdvisorService from '@advisor/rwSdk/AdvisorService';

const stateObj = function () {
  return new ManageFirm();
};

const getters = {
  getPrimaryOffice: (state) => {
    if (state.firmOffices?.length) {
      return state.firmOffices.find((item) => item.isPrimaryOffice === true);
    }

    return {};
  },
  getCustodians: (state) => state.custodians,
};

const actions = {
  /** ***************************** Manage Firm Api start ***************************************************************** */
  /**
   * This will fetch firm information based on firmId
   * @param {firmId} payload
   */
  async getFirmInfo({commit}, payload) {
    try {
      const apiCall = await ManageFirmService.getFirmInfo(payload);

      returnNoneApi(apiCall);
      commit('SET_FIRM_INFO', apiCall.data);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('manageFirm.getFirmInfo', error);

      return Promise.reject(error);
    }
  },

  /**
   * This will update firm information based on firmId
   * @param {firmId} payload
   */
  async updateFirmInfo({commit}, payload) {
    try {
      const apiCall = await principalAdvisorService.postRiaFirmRiaId(payload);

      commit('UPDATE_FIRM_INFO', apiCall);

      return apiCall;
    } catch (error) {
      exceptionHandler.handleGenericException('manageFirm.updateFirmInfo', error);

      return Promise.reject(error);
    }
  },

  /**
   * This will fetch ria offices information based on firmId
   * @param {firmId} payload
   */
  async getOfficeInfo({commit}, payload) {
    try {
      const apiCall = await principalAdvisorService.getRiaFirmOffice(payload);

      commit('SET_OFFICE_INFO', apiCall);

      return apiCall;
    } catch (error) {
      exceptionHandler.handleGenericException('manageFirm.getOfficeInfo', error);

      return Promise.reject(error);
    }
  },
  /**
   * This will update firm office information based on officeId
   * @param {officeId} payload
   */
  async updateOfficeInfo({commit}, payload) {
    try {
      const apiCall = await principalAdvisorService.postRiaFirmOffice(payload);

      commit('UPDATE_OFFICE_INFO', apiCall);

      return apiCall;
    } catch (error) {
      exceptionHandler.handleGenericException('manageFirm.updateOfficeInfo', error);

      return Promise.reject(error);
    }
  },
  /**
   * This will fetch Custodian List for that firm
   * @param {firmId} payload
   */
  async getCustodians({commit}, payload) {
    try {
      const apiCall = await ManageFirmService.getCustodianList(payload);

      returnNoneApi(apiCall);
      commit('SET_CUSTODIANS', apiCall.data);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('manageFirm.getCustodians', error);

      return Promise.reject(error);
    }
  },
  /**
   * This will fetch Custodian List for that firm
   * @param {firmId} payload
   */
  async getTDRepCodes({commit}, payload) {
    try {
      const apiCall = await ManageFirmService.getTDRepCodes(payload);

      returnNoneApi(apiCall);
      commit('SET_TD_REPCODES', apiCall.data);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('manageFirm.getTDRepCodes', error);

      return Promise.reject(error);
    }
  },
  async saveTDRepCodes({commit}, payload) {
    try {
      const apiCall = await ManageFirmService.saveTDRepCodes(payload);

      returnNoneApi(apiCall);
      commit('SET_TD_REPCODES', apiCall.data);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('manageFirm.saveTDRepCodes', error);

      return Promise.reject(error);
    }
  },
  async updateTDRepCodes({commit}, payload) {
    try {
      const apiCall = await ManageFirmService.updateTDRepCodes(payload);

      returnNoneApi(apiCall);
      commit('SET_TD_REPCODES', apiCall.data);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('manageFirm.updateTDRepCodes', error);

      return Promise.reject(error);
    }
  },
  async addCustodian({commit}, payload) {
    try {
      const apiCall = await ManageFirmService.addCustodian(payload);

      returnNoneApi(apiCall);
      commit('SET_CUSTODIANS', apiCall.data);

      return apiCall.data;
    } catch (error) {
      exceptionHandler.handleGenericException('manageFirm.addCustodian', error);

      return Promise.reject(error);
    }
  },
};

const mutations = {
  SET_FIRM_INFO(state, payload) {
    state.firm = payload.data;
  },
  SET_OFFICE_INFO(state, payload) {
    state.firmOffices = payload;
  },
  UPDATE_FIRM_INFO(state, payload) {
    state.firm = payload;
  },
  UPDATE_OFFICE_INFO(state, payload) {
    state.firmOffices = payload;
  },
  SET_CUSTODIANS(state, payload) {
    state.custodians = payload.data;
  },
  SET_TD_REPCODES(state, payload) {
    state.repCodes = payload.data;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
